import campaignUserReducer from '@/containers/Campaign/Users/redux/reducer';
import campaignSunrise25UserReducer from '@/containers/Campaign/Sunrise25Users/redux/reducer';

export const CampaignReducers = {
  campaignUser: campaignUserReducer,
  campaignSunrise25User: campaignSunrise25UserReducer,
};
